import { useEffect, useState } from "react";

const resolveInitialValue = (initialValue) =>
  typeof initialValue === "function" ? initialValue() : initialValue;

export const usePersistentState = (storageKey, initialValue) => {
  const [state, setState] = useState(() => {
    const fallbackValue = resolveInitialValue(initialValue);

    try {
      const savedValue = localStorage.getItem(storageKey);
      return savedValue !== null ? JSON.parse(savedValue) : fallbackValue;
    } catch (error) {
      console.error(`Failed to restore persisted state for ${storageKey}`, error);
      return fallbackValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      console.error(`Failed to persist state for ${storageKey}`, error);
    }
  }, [storageKey, state]);

  return [state, setState];
};

export default usePersistentState;
